module.exports = __webpack_public_path__ + "static/media/21ECLAC19.26619ce6.jpg";